// extracted by mini-css-extract-plugin
module.exports = {"container":"HeaderHomePage_container__h4yZA","menuBox":"HeaderHomePage_menuBox__IQU2f","hide":"HeaderHomePage_hide__EmLUo","hideHeader":"HeaderHomePage_hideHeader__kAk_x"};